import home from "@motain/web-shared-hub/assets/icons/OFLongIconWhite.svg";
import homeDark from "@motain/web-shared-hub/assets/icons/OFLongIconDark.svg";
import { FooterProps } from "@motain/web-shared-hub/ui/blocks";
import { TFunction } from "i18next";

export const FooterConfig = (
  isDarkMode: boolean,
  t: TFunction,
): FooterProps => {
  return {
    title: t("FOOTER_FOLLOW_US"),
    privacySettingsLinkTitle: t("PRIVACY SETTINGS"),
    icon: {
      src: home,
      darkModeSrc: homeDark,
      alt: "home",
      width: 150,
      height: 24,
      isDarkMode: isDarkMode,
    },
    sections: [
      {
        title: t("FOOTER_ABOUT_US"),
        links: [
          { title: t("FOOTER_COMPANY_TITLE"), url: t("FOOTER_COMPANY_URL") },
          { title: t("FOOTER_CAREERS"), url: t("FOOTER_CAREERS_URL") },
          { title: t("FOOTER_CONTACT"), url: t("FOOTER_CONTACT_URL") },
          {
            title: t("FOOTER_HELP_CENTER"),
            url: t("FOOTER_HELP_CENTER_URL"),
          },
        ],
      },
      {
        title: t("FOOTER_PARTNER_WITH_US"),
        links: [
          { title: t("FOOTER_SALES"), url: t("FOOTER_SALES_URL") },
          { title: t("FOOTER_CLFP"), url: t("FOOTER_CLFP_URL") },
          { title: t("FOOTER_PUBLISHER"), url: t("FOOTER_PUBLISHER_URL") },
          {
            title: t("FOOTER_BRAND_SOLUTIONS"),
            url: t("FOOTER_BRAND_SOLUTIONS_URL"),
          },
        ],
      },
      {
        title: t("FOOTER_LEGAL"),
        links: [
          {
            title: t("FOOTER_IMPRINT"),
            url: t("FOOOTER_IMPRINT_URL"),
          },
          {
            title: t("FOOTER_PRIVACY_POLICY"),
            url: t("FOOTER_PRIVACY_POLICY_URL"),
          },
          {
            title: t("FOOTER_TERMS_AND_CONDITIONS"),
            url: t("FOOTER_TERMS_AND_CONDITIONS_URL"),
          },
          {
            title: t("FOOTER_EN_DS_INFORMATION"),
            url: t("FOOTER_EN_DS_INFORMATION_URL"),
          },
        ],
      },
      {
        title: t("FOOTER_MORE_IN_OF"),
        links: [
          {
            title: "App Store",
            url: "https://apps.apple.com/us/app/onefootball/id382002079",
          },
          {
            title: "Google Play",
            url: "https://play.google.com/store/apps/details?id=de.motain.iliga",
          },
          {
            title: "OneFootball Merch",
            url: "https://store.onefootball.com/",
          },
          {
            title: "TV App",
            url: "https://company.onefootball.com/tv-app/",
          },
        ],
      },
    ],
    socialMedia: [
      {
        title: "Instagram",
        url: "https://www.instagram.com/onefootball",
        handle: "@onefootball",
        icon: {
          src: "https://images.onefootball.com/cw/icons/instagram_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/instagram_dark.svg",
          alt: "Instagram icon",
          isDarkMode: isDarkMode,
        },
      },
      {
        title: "Facebook",
        url: "https://www.facebook.com/OneFootball",
        handle: "@OneFootball.de",
        icon: {
          src: "https://images.onefootball.com/cw/icons/facebook_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/facebook_dark.svg",
          alt: "Facebook icon",
          isDarkMode: isDarkMode,
        },
      },
      {
        title: "Twitter",
        url: "https://twitter.com/Onefootball",
        handle: "@OneFootball",
        icon: {
          src: "https://images.onefootball.com/cw/icons/twitter_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/twitter_dark.svg",
          alt: "Twitter icon",
          isDarkMode: isDarkMode,
        },
      },
      {
        title: "Youtube",
        url: "https://www.youtube.com/user/Onefootball",
        handle: "@OneFootball",
        icon: {
          src: "https://images.onefootball.com/cw/icons/youtube_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/youtube_dark.svg",
          alt: "Youtube icon",
          isDarkMode: isDarkMode,
        },
      },
      {
        title: "TikTok",
        url: "https://www.tiktok.com/@onefootball",
        handle: "@onefootball",
        icon: {
          src: "https://images.onefootball.com/cw/icons/tiktok_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/tiktok_dark.svg",
          alt: "TikTok icon",
          isDarkMode: isDarkMode,
        },
      },
      {
        title: "AudioBoom",
        url: "https://audioboom.com/channel/onefootball",
        handle: "@OneFootball",
        icon: {
          src: "https://images.onefootball.com/cw/icons/audioboom_light.svg",
          darkModeSrc:
            "https://images.onefootball.com/cw/icons/audioboom_dark.svg",
          alt: "AudioBoom icon",
          isDarkMode: isDarkMode,
        },
      },
    ],
  };
};
